// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__bUePo","backButton":"ModalHeader_backButton__vtIn+","Button":"ModalHeader_Button__+V60y"};